import { EmailLocation } from './types';

// Recipients before sending, as the audience endpoints count them (CUD-5778).
export interface RecipientEstimate {
    // False until the count arrives (or when it can't be counted, e.g. no locations yet).
    known: boolean;
    total: number;
    duplicates: number;
    unsubscribed: number;
    excluded: number;
    byLocation: Array<{ location: EmailLocation; count: number }>;
}

export const UNKNOWN_ESTIMATE: RecipientEstimate = {
    known: false,
    total: 0,
    duplicates: 0,
    unsubscribed: 0,
    excluded: 0,
    byLocation: []
};
